import React from "react";
import classes from "./InvalidMessage.module.scss";
import cl from "classnames";

function InvalidMessage(props) {
  const { classname = "", error = "" } = props;
  const msg = error.message || error;
  return (
    <div
      className={cl(
        classes["invalid-message"],
        { [classes["has-error"]]: msg },
        classname
      )}
    >
      {msg}
    </div>
  );
}

export default InvalidMessage;
